import axios from 'axios';

const apiService = {

  async get(url, params = {}, autoLogin) {
  let token = localStorage.getItem('accessToken');

  if (!token) {
    if (autoLogin) await autoLogin();
    token = localStorage.getItem('accessToken');
    // if (!token) throw new Error('Access token is missing.');
  }

  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401 && autoLogin) {
      const success = await autoLogin();
      if (success) {
        const newToken = localStorage.getItem('accessToken');
        return axios.get(url, {
          headers: { Authorization: `Bearer ${newToken}` },
          params,
        });
      }
    }

    //console.error(`GET request to ${url} failed:`, error);
    throw error;
  }
}
,

 async post(url, data = {}, autoLogin) {
  let token = localStorage.getItem('accessToken');

  // If no token → try autoLogin
  if (!token && autoLogin) {
    const success = await autoLogin();
    if (success) {
      token = localStorage.getItem('accessToken');
    }
  }

  if (!token) {
    throw new Error('Access token is missing.');
  }

  try {
    const response = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response;
  } catch (error) {

    // If unauthorized → try autoLogin once and retry
    if (error.response?.status === 401 && autoLogin) {
      const success = await autoLogin();

      if (success) {
        const newToken = localStorage.getItem('accessToken');

        return axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`,
            'Content-Type': 'application/json'
          }
        });
      }
    }

    //console.error(`POST request to ${url} failed:`, error);
    // throw error;
  }
},

  async patch(url, data = {}, autoLogin) {
  let token = localStorage.getItem('accessToken');

  // If no token → try autoLogin
  if (!token && autoLogin) {
    const success = await autoLogin();
    if (success) {
      token = localStorage.getItem('accessToken');
    }
  }

  if (!token) {
    // throw new Error('Access token is missing.');
  }

  try {
    const response = await axios.patch(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response;
  } catch (error) {

    // If unauthorized → try autoLogin once and retry
    if (error.response?.status === 401 && autoLogin) {
      const success = await autoLogin();

      if (success) {
        const newToken = localStorage.getItem('accessToken');

        return axios.patch(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`,
            'Content-Type': 'application/json'
          }
        });
      }
    }

    // console.error(`PATCH request to ${url} failed:`, error);
    // throw error;
  }
}
,

  async delete(url, data = {}, autoLogin) {
  let token = localStorage.getItem('accessToken');

  // If no token → try autoLogin
  if (!token && autoLogin) {
    const success = await autoLogin();
    if (success) {
      token = localStorage.getItem('accessToken');
    }
  }

  if (!token) {
    // throw new Error('Access token is missing.');
  }

  try {
    const response = await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data,
    });

    return response;
  } catch (error) {

    // If unauthorized → try autoLogin once and retry
    if (error.response?.status === 401 && autoLogin) {
      const success = await autoLogin();

      if (success) {
        const newToken = localStorage.getItem('accessToken');

        return axios.delete(url, {
          headers: {
            Authorization: `Bearer ${newToken}`,
            'Content-Type': 'application/json'
          },
          data,
        });
      }
    }

    // console.error(`DELETE request to ${url} failed:`, error);
    // throw error;
  }
}
,
};

export default apiService;
